import React from 'react';
import { Backdrop } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types'; // ES6

const useStyles = makeStyles((theme) => ({
    backdrop: {
        // zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function CustomBackdrop(props) {
    const classes = useStyles();
    const { open } = props
    return (
        <div>
            <Backdrop className={classes.backdrop} open={open} onClick={_ => props.handleClick} sx={{ zIndex: 100001 }} >
                <CircularProgress />
            </Backdrop>
        </div>
    );
}

CustomBackdrop.propTypes = {
    open: PropTypes.bool,
}
